import { render, staticRenderFns } from "./ReportEdit_new.vue?vue&type=template&id=58c1cf37&"
import script from "./ReportEdit_new.vue?vue&type=script&lang=js&"
export * from "./ReportEdit_new.vue?vue&type=script&lang=js&"
import style0 from "./ReportEdit_new.vue?vue&type=style&index=0&id=58c1cf37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports